import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

const useSuperUserPermission = () => {
  const [canCreateSuperUser, setCanCreateSuperUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const checkSuperUserPermission = async () => {
      if (user && user.token) {
        try {
          // const response = await axios.get('http://localhost:4000/api/user/check-superuser-permission', {
          const response = await axios.get(process.env.REACT_APP_API_EXTENDED_NEURO_URL + '/user/check-superuser-permission', {
            headers: {
              'Authorization': `Bearer ${user.token}`
            }
          });
          setCanCreateSuperUser(response.data.canCreateSuperUser);
        } catch (error) {
          console.error('Error checking SuperUser permission:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    checkSuperUserPermission();
  }, [user]);

  return { canCreateSuperUser, loading };
};

export default useSuperUserPermission;

